<template>    
<v-layout row wrap>
    <v-flex id="listaCatalogo">
        <!--toolbarListaCatalogo/>
        Sustituido por systembar -->
        <ul>
            <li v-for="error in errors" :key="error.id">
                <v-alert :value="true" color="error" icon="warning"> {{ error.msg }}
                </v-alert>      
            </li>                  
        </ul>
        
        <v-list dense two-line id="listaProductos">   
            <v-container
            id="scroll-targetMobile"            
            :style="maxHeight"
            class="scroll-y"
            fluid
            pa-0
            >  
                <carouselPromociones v-if="$store.state.appconfig.promociones"/>
                <v-data-iterator
                id="iteratorgridsmall"
                :items="items"
                :rows-per-page-items="rowsPerPageItems"
                :rows-per-page-text="rowsPerPageText"    
                :pagination.sync="pagination"
                :page.sync="pagination.page"
                @update:pagination="updatePage"
                >                    
                    <template v-slot:item="props">
                            <v-card
                                :loading="loading"
                                class="mx-auto my-12 gridSmall"
                                v-if="props.item.visible"
                            >
                                <template slot="progress">
                                <v-progress-linear
                                    color="deep-purple"
                                    height="10"
                                    indeterminate
                                ></v-progress-linear>
                                </template>

                                <v-layout row wrap>
                                    <v-flex xs5>
                                        <v-img
                                        v-if="props.item.pictureL != ''"
                                        height="150"
                                        :src="props.item.pictureL"
                                        @click="openDialog(props.item)"
                                        :lazy-src="props.item.pictureN"
                                        ></v-img>
                                        <v-img
                                        v-if="props.item.pictureL == ''"
                                        height="150"
                                        :src="require('../assets/noimage.png')"
                                        @click="openDialog(props.item)"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex xs7>
                                        <v-card-title dense class="cardTitleGrid">{{props.item.description}} </v-card-title>
                                        <div class="subtitleGrid"><span class="itemAlias">{{ props.item.Alias }}</span></div>
                                        <div class="subtitleGrid"><span class="itemIdCard">{{ props.item.no }}</span></div>
                                        
                                        <v-card-text v-if="(props.item.promoCode != null) || (props.item.customerDiscount != 0) || (props.item.customerDscntGroupDiscount != 0) || (props.item.allCustomersDiscount != 0) || (props.item.descuentos.length > 0)">
                                            <v-layout class='inneritemflex' row>
                                                <v-flex xs11 md10 @click="openDialog(props.item)">
                                                    <v-layout row>
                                                        <div v-if="props.item.promoCode != null" class="promoImg" title="Tiene promociones"/>
                                                        <div v-if="(props.item.customerDiscount != 0) || (props.item.customerDscntGroupDiscount != 0) || (props.item.allCustomersDiscount != 0)" class="dtoImg" title="Tiene descuentos"/>
                                                        <v-flex xs10>                             
                                                            <div v-if="props.item.promoCode != null" class="promoDiv">Ver Promociones</div>
                                                            <div v-else-if="props.item.descuentos.length > 0" class="promoDiv">Ver Descuentos</div>
                                                        </v-flex>  
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-text>
                                            <v-layout row>
                                                <v-flex v-if="(props.item.disponible > 0) && ($store.state.usuario.type == 'Comercial')" xs12>
                                                    <a @click.prevent="$store.state.availabilityListVisible = true">Existencias: <span class="available">{{props.item.disponible}}</span></a>
                                                </v-flex>
                                                <v-flex v-if="(props.item.disponible > 0) && ($store.state.usuario.type != 'Comercial')" xs12>
                                                    <a @click.prevent="$store.state.availabilityListVisible = true">Existencias: <v-icon class="available">done</v-icon> </a>
                                                </v-flex>
                                                <v-flex v-if="(props.item.disponible <= 0) && ($store.state.usuario.type == 'Comercial')" xs12>
                                                    Existencias: <span class="nostock">{{props.item.disponible}}</span>
                                                </v-flex>      
                                                <v-flex v-if="(props.item.disponible <= 0) && ($store.state.usuario.type != 'Comercial')" xs12>
                                                    Existencias: <v-icon class="nostock">not_interested</v-icon>
                                                </v-flex>                                                                                                 
                                                <v-flex v-if="$store.state.appconfig.showLineCategories" xs4 >
                                                    {{props.item.categoryName}}, {{props.item.groupName}}
                                                </v-flex> 
                                            </v-layout>   
                                            <v-layout row>                                
                                                <v-flex v-if="$store.state.appconfig.showLineCategories" xs3 class="priceTag">
                                                    {{props.item.precio}} €
                                                </v-flex>     
                                                <v-flex v-if="!$store.state.appconfig.showLineCategories" xs8 class="priceTag">
                                                    {{props.item.precio}} €
                                                </v-flex>       
                                            </v-layout>
                                        </v-card-text>
                                        
                                        <v-text-field v-model="props.item.cantidad" name="cantidad"  v-validate="'min_value:0'" @focus="$event.target.select()" @change="commitToCart(props.item)" type="number" append-outer-icon="add" @click:append-outer="increment(props.item)" prepend-icon="remove" @click:prepend="decrement(props.item)" ></v-text-field>
                                        <!--v-card-actions>
                                        <v-btn
                                            color="deep-purple lighten-2"
                                            text                                    
                                            @click="openDialog(props.item)"
                                        >
                                            Comprar
                                        </v-btn>
                                        </v-card-actions-->
                                    </v-flex>
                                </v-layout>
                            </v-card>
                    </template>

                    <template v-slot:no-data>
                        <v-alert :value="true" color="error" icon="warning" v-if="!topventas">
                            Sin resultados.
                        </v-alert>
                        <v-alert :value="true" color="error" icon="warning" v-if="topventas">
                            Sin resultados. Registre ventas al cliente para que se cree su top ventas.
                        </v-alert>
                    </template>
                </v-data-iterator>
            </v-container> 
        </v-list>     
        <dialogEditItemMobile >
        </dialogEditItemMobile>
    <!--/v-card-->
    </v-flex>
</v-layout>
</template>
<script>
import dialogEditItemMobile from '@/components/dialogEditItemMobile'
import toolbarListaCatalogo from '@/components/toolbarListaCatalogo'
import promocionesDestacadas from '@/components/promocionesDestacadas'
import carouselPromociones from '@/components/carouselPromociones'
export default {
    //mixins:[mixin],
    name: 'listacatalogomobile',
    components:{
        dialogEditItemMobile,
        toolbarListaCatalogo,
        promocionesDestacadas,
        carouselPromociones
    },
    data () {
      return {     
        lotSelection: null,
        rowsPerPageItems: [20, 40, 60],
        rowsPerPageText: 'Productos por página',
        pagination: {
            rowsPerPage: 20,
            page: 5,
            pageStart: 1,
            totalItems: 1
        },   
        Promociones: true,
        openSearch: false,
        fullscreen: true,
        timeoutCommit: null,
		toggle_exclusive: 0,
        loading: false,
        maxHeight: 'max-height: 85vh',
      }
    },
    methods:{    
        updatePage (pagination) {
            // detect change in itemsPerPage
            if (this.itemsPerPage !== pagination.itemsPerPage) {
                for (let p = 0; p < pagination.pageCount; p++) {
                    // figure out the page bounds
                    const start = p * pagination.itemsPerPage
                    const end = start + pagination.itemsPerPage
                    // is the target item on this page?
                    if (this.firstItem >= start && this.firstItem < end) {
                        // yes, so set the page to this page
                        pagination.page = p + 1
                        // break out of the loop
                        break;
                    }
                }
            }
            // update the pagination info
            this.pagination = pagination;
            window.scrollTo(0, 0);
            var scrolldiv = document.getElementById('scroll-targetMobile');
            if (scrolldiv) scrolldiv.scrollTop = 0;
        },                                               
        imageLoadError (index) {
            //console.log('Image failed to load');
            var res = this.items.filter(itm=>{
                return itm.no == index;
            });
            var file = require('../assets/noimage.png');
            for (var i = 0; i < res.length; i++){                
                res[i].Picture = file;
            }            
        },
        increment (item) {
            var thisaux = this;
            clearTimeout(this.timeoutCommit);
            item.cantidad = parseFloat(item.cantidad) + 1;
            this.timeoutCommit = setTimeout(function(){ 
                for (var i = 0; i < thisaux.listitems.length;){
                    if (thisaux.listitems[i].isPromo && (thisaux.listitems[i].fromitemNo == item.no)){
                        thisaux.listitems.splice(i, 1);
                    } else {
                        i++;
                    }
                }                
                thisaux.commitToCart(item,false,true);
            }, 1200);
        },
        decrement (item) {
            var thisaux = this;
            if (item.cantidad > 0){
                clearTimeout(this.timeoutCommit);
                item.cantidad = parseFloat(item.cantidad) - 1;
                this.timeoutCommit = setTimeout(function(){
                    for (var i = 0; i < thisaux.listitems.length;){
                        if (thisaux.listitems[i].isPromo && (thisaux.listitems[i].fromitemNo == item.no)){
                            thisaux.listitems.splice(i, 1);
                        } else {
                            i++;
                        }
                    }
                    thisaux.commitToCart(item,false,true);                           
                }, 1200);
            }
        }, 
        calcMaxHeight(y){
            var factor = 1000;
            factor -= y;
            factor = factor/100;
            factor = factor*factor;
            
            var vhVal = 75 - factor;
            if (this.promoVisibles && (this.$store.state.promosDestacadas.length != 0))
                vhVal = 40 - factor;

            this.maxHeight = 'max-height: ' + vhVal + 'vh';
            //console.log(this.maxHeight);
            //console.log(this.promoVisibles );
        },       
        getMaxHeight(){
            if (this.$store.state.promosDestacadasVisible && (this.$store.state.promosDestacadas.length != 0)){
                return 'max-height: calc(100vh - 190px)'
            } else {
                return 'max-height: calc(100vh - 290px)'
            }
        }
    },
    created(){       
       this.getItems();   
       //this.calcMaxHeight(window.innerHeight);              
    },
    mounted(){                       
        if (this.$store.state.reloadMenu){
            this.$store.state.reloadMenu = false;
            window.location.reload();
        } else { 
            if ((this.$store.state.usuario.type == 'Comercial') && ((this.$store.state.customer.no == '') || (this.$store.state.tipoDocumento == ''))){
                this.$store.state.tipoDocumento = this.$store.state.appconfig.defaultOrderType;                  
                this.$store.commit('setDialogComercial',true);
            }
        }
    },
    watch: {
        windowSize: function(val){
            //this.calcMaxHeight(val.y);
        },
        promoVisibles: function(val){
           //this.calcMaxHeight(this.windowSize.y);
        },
        promosDestacadas: function(val){
            //this.calcMaxHeight(this.windowSize.y);
        }
    },
    computed: {             
        items:{
            get(){
                return this.$store.state.items;
            },
            set(value){
                this.$store.commit('setItems',value);
            }
        },         
        topventas: {
            get(){
                return this.$store.state.topventas;
            },
            set(value){
                this.$store.commit('setTopVentas', value)
            }
        },
        dialog:{
            get(){
                return this.$store.state.dialogEditItem;
            },
            set(value){
                this.$store.state.dialogEditItem = value;
            }
        },
        dialogData:{
            get(){
                return this.$store.state.dialogData;
            },
            set(value){
                this.$store.state.dialogData = value;
            }
        },
        editedItems:{
            get(){
                return this.$store.state.editedItems;
            },
            set(value){
                this.$store.state.editedItems = value;
            }
        },
        editedIndex:{
            get(){
                return this.$store.state.editedIndex;
            },
            set(value){
                this.$store.state.editedIndex = value;
            }
        },
        sameNoItems:{
            get(){
                return this.$store.state.sameNoItems;
            },
            set(value){
                this.$store.state.sameNoItems = value;
            }
        },
        sameNoItemsBackup:{
            get(){
                return this.$store.state.sameNoItemsBackup;
            },
            set(value){
                this.$store.state.sameNoItemsBackup = value;
            }
        },
        listitems: {
            get(){
                return this.$store.state.orderItems;
            },
            set(value){
                this.$store.commit('setOrderItems',value)
            }
        },
        windowSize:{
            get(){
                return this.$store.state.windowSize;
            },
            set(value){
                this.$store.state.windowSize = value;
            }
        },
        promosDestacadas:{
            get(){
                return this.$store.state.promosDestacadas;
            },
        },
        promoVisibles:{
            get(){
                return this.$store.state.promosDestacadasVisible;
            },
            set(value){
                //this.$store.state.promosDestacadasVisible = value;
                this.$store.commit('setPromosVisible',value);
            }
        }
    }    
}
</script>
<style scoped>
.nopadding{
    padding: 0px !important;
}
 .noborderradius{
     border-radius: 0px !important;
 }
 .cardTitleGrid{
     padding-bottom: 2px !important;
     height: auto;
 }
 .subtitleGrid{
     padding-left: 15px;;
 }
 .itemId{
     color: gray;
     font-weight: 200;
     padding-left: 15px;
 }
  .itemIdCard{
     color: gray;
     font-weight: 200;
     font-size: smaller;
 }
  .itemAlias{
     color: gray;
     font-size: smaller;
 }
 .inneritemflex{
     width: 100%;
 }
 .noLeftPadding{
     padding-left: 0px !important;
 }
.halfwidth{
    width: 50%;
}
.halfheight{
    height: 50% !important;
}
.h20{
    height: 20px !important;
}
.hauto{
    height: auto !important;
}
div.v-list__group__header{
    height: 30px !important;
}
.p-left10{
    padding-left: 10px;
}
#listaCatalogo{
    
}
#listaProductos{
    padding-top: 0px;
}

 #iteratorgridsmall > div:nth-of-type(odd) {
    background-color: rgba(88, 151, 251, .12);
}
.available{
    color: green;
}
.nostock{
    color: red;
}
.itemQtyInput{
    position: absolute;
    right: 0px;
}
.promoImg {
    width:20px;
	height:20px;
	background-image: url(data:image/svg+xml;utf8;base64,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)
}
.dtoImg {
    margin-top: 5px;
    width:20px;
	height:20px;
	background-image: url(data:image/svg+xml;utf8;base64,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)
}
.promoDiv{
    display: inline-flex;
    color: #2196f3;
}
.priceTag{
    font-size: 15px;
    font-weight: bold;
}
.gridBig{
    width: 47%;
    margin-right: 3% !important;
    margin-bottom: 2%;
    display: inline-block;
    
}
.gridSmall{
    width: 96%;
    margin-left: 2% !important;
    margin-bottom: 2%;
    display: inline-block;
}
.textCenter{
    text-align: center;
}
</style>



